import { render, staticRenderFns } from "./ServiceProposal.vue?vue&type=template&id=14f282c0&"
import script from "./ServiceProposal.vue?vue&type=script&lang=js&"
export * from "./ServiceProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports